import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import CustomButton from "../../../core/components/ui/CustomButton"
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Paper, Skeleton, Stack, alpha, useTheme } from "@mui/material";
import CustomTypography from "../../../core/components/ui/CustomTypography";
import { useGates } from "../hooks/useGates";
import { useEffect } from "react";
import CustomChipComponent from "../../../core/components/common/custom-chip.component";

const ViewGatePage = () => {

    const theme = useTheme();

    const navigate = useNavigate()
    const [searchParams] = useSearchParams();

    const {isLoadingViewGate, gate, errorViewGate, viewGate} = useGates()
    const gate_uid = searchParams.get('id');

    useEffect(() => {
        viewGate(gate_uid)
    }, [])
    

    const handleBack = () => {
        navigate("/gates"); 
    }

    return(
        <>
            <CustomButton 
                variant="text" 
                startIcon={<ArrowBackIcon fontSize="small" />}
                label="Back to Gate List"
                customStyles={{fontSize: 14, ml: -2}}
                onClick={handleBack}
            />

            <Box sx={{textAlign: "start", mt: 2}}>
                <CustomTypography 
                    variant="h3"
                    text={"Gate Details"}
                    customStyles={{
                        marginBottom: 0, 
                    }}
                />

                <CustomTypography 
                    variant="subtitle1"
                    text={"View Gate Information"}
                    customStyles={{
                        marginBottom: 0, 
                    }}
                />
            </Box>

            <Paper elevation={0} sx={{border: `1px solid #e5edf6`, borderRadius: 2, padding: "24px 32px", mt: 3}}>
                <CustomTypography 
                    variant="caption" 
                    text={"Gate Reference"} 
                    customStyles={{
                        marginBottom: 0, 
                    }}
                />

                {(isLoadingViewGate) ?
                    <Skeleton variant="text" height="35px" width="34%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                : 
                    <CustomTypography
                        variant="body1"
                        text={(gate?.gate_uid)}
                        customStyles={{
                            marginBottom: 0, 
                            fontWeight: 600,
                        }}
                    />
                }

                <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 2
                    }}
                    >
                    <Box flex={1}>
                        <CustomTypography 
                            variant="caption" 
                            text={"Port"} 
                            customStyles={{
                                marginBottom: 0, 
                            }}
                        />

                        {(isLoadingViewGate) ?
                            <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                        :
                            <CustomTypography
                                variant="body1"
                                text={gate?.portEntity?.port_name ? gate?.portEntity?.port_name : "N/A"}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        }
                    </Box>

                    <Box flex={1}>
                        <CustomTypography 
                            variant="caption" 
                            text={"Gate Type"} 
                            customStyles={{
                                marginBottom: 0, 
                            }}
                        />

                        {(isLoadingViewGate) ?
                            <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                        :
                            <CustomTypography
                                variant="body1"
                                text={gate?.type}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        }
                    </Box>

                    <Box sx={{display: "inline-grid"}} flex={1}>
                        <CustomTypography 
                            variant="caption" 
                            text={"Status"} 
                            customStyles={{
                                marginBottom: 0, 
                            }}
                        />

                        {(isLoadingViewGate) ?
                            <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                        :
                            <CustomChipComponent category="portStatus"
                                label={(gate?.status === "Active") ? "Active" 
                                    : 
                                        (gate?.status === "Deactivated") ? "Deactivated"
                                    :
                                        gate?.status
                                }
                            />
                        }
                    </Box>
                    <Box flex={1} />
                </Stack>

                <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                    >
                    <Box flex={1}>
                        <CustomTypography 
                            variant="caption" 
                            text={"Gate Name"} 
                            customStyles={{
                                marginBottom: 0, 
                            }}
                        />

                        {(isLoadingViewGate) ?
                            <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                        :
                            <CustomTypography
                                variant="body1"
                                text={gate?.gatename}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        }
                    </Box>

                    <Box flex={1}>
                        <CustomTypography 
                            variant="caption" 
                            text={"Gate Location"} 
                            customStyles={{
                                marginBottom: 0, 
                            }}
                        />

                        {(isLoadingViewGate) ?
                            <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                        :
                            <CustomTypography
                                variant="body1"
                                text={gate?.location}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        }
                    </Box>
                    <Box flex={1} />
                    <Box flex={1} />
                </Stack>
            </Paper>
        </>
    )
}

export default ViewGatePage